/**
 * @file
 * GVDT Theme behaviors.
 */
(function (Drupal, drupalSettings, once, feather) {
  'use strict';

  Drupal.behaviors.sidebarNavigation = {
    attach: function (context, settings) {
      // Ensure the script only runs once per page load.
      if (context !== document) {
        return;
      }

      // Get current URL and path.
      const url = window.location.href;
      const path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");

      // Select sidebar navigation links.
      const sidebarLinks = document.querySelectorAll("ul#sidebarnav a");

      sidebarLinks.forEach((link) => {
        if (link.href === url || link.getAttribute("href") === path) {
          let parentElement = link.parentElement;

          while (parentElement && !parentElement.classList.contains("sidebar-nav")) {
            if (parentElement.tagName === "LI") {
              const anchor = parentElement.querySelector("a");
              if (anchor) {
                anchor.classList.add("active");
              }
              parentElement.classList.add("active");
            } else if (parentElement.tagName === "UL") {
              parentElement.classList.add("in");
            }
            parentElement = parentElement.parentElement;
          }
        }
      });
    },
  };

  Drupal.behaviors.featherIcons = {
    attach: function (context, settings) {
      feather.replace();
    }
  };

  Drupal.behaviors.navToggle = {
    attach: function (context, settings) {
      const navToggle = once('navToggle', '#nav-toggle', context)[0];
      const dbWrapper = document.querySelector('#db-wrapper');

      if (navToggle && dbWrapper) {
        // Set initial state from localStorage
        const isToggled = localStorage.getItem('dbWrapperToggled') === 'true';
        if (isToggled) {
          dbWrapper.classList.add('toggled');
        } else {
          dbWrapper.classList.remove('toggled');
        }

        // Event listener
        navToggle.addEventListener('click', function (e) {
          e.preventDefault();
          dbWrapper.classList.toggle('toggled');

          // Save current state
          const currentState = dbWrapper.classList.contains('toggled');
          localStorage.setItem('dbWrapperToggled', currentState);
        });
      }
    },
  };


  Drupal.behaviors.avatarBackground = {
    attach(context, settings) {
      document.querySelectorAll('.avatar:not(.avatar--processed)', context).forEach((avatar) => {
        avatar.classList.add('avatar--processed');

        const username = avatar.dataset.username;

        if (username && !avatar.querySelector('img')) {
          const color = stringToDarkColor(username);
          avatar.style.backgroundColor = color;
          avatar.style.color = '#FFFFFF'; // Always white text

          const initials = username
            .split(' ')
            .map((namePart) => namePart.charAt(0).toUpperCase())
            .join('')
            .substring(0, 2);

          avatar.textContent = initials;
        }
      });

      function stringToDarkColor(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        // Convert hash to HSL and limit lightness
        const hue = Math.abs(hash) % 360;
        const saturation = 60 + (Math.abs(hash) % 20); // 60% - 80%
        const lightness = 30 + (Math.abs(hash) % 20); // 30% - 50%, stays dark

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      }
    },
  };

  Drupal.behaviors.copyNidToClipboard = {
    attach: function (context, settings) {

      // Helper to enable and show a Bootstrap tooltip
      function showBootstrapTooltip(element, message) {
        // Set title attribute for tooltip text
        element.setAttribute('title', message);

        // Dispose any existing tooltip (to re-init with new title)
        bootstrap.Tooltip.getInstance(element)?.dispose();

        // Init tooltip with updated message
        const tooltip = new bootstrap.Tooltip(element, {
          trigger: 'manual',
        });

        tooltip.show();

        // Hide tooltip after 2 seconds
        setTimeout(() => {
          tooltip.hide();
          tooltip.dispose();
          element.removeAttribute('title');
        }, 2000);
      }

      // DRY helper to bind click-to-copy
      function makeCopyable(elements, className) {
        elements.forEach((element) => {
          if (element.classList.contains(className)) return;

          element.classList.add(className);

          element.addEventListener('click', function () {
            const text = element.textContent.trim();

            navigator.clipboard.writeText(text)
              .then(() => {
                console.log(`Copied to clipboard: ${text}`);
                showBootstrapTooltip(element, 'Copied to clipboard!');
              })
              .catch(err => {
                console.error('Clipboard error: ', err);
                showBootstrapTooltip(element, 'Failed to copy');
              });
          });
        });
      }

      // Selectors
      const nidElements = context.querySelectorAll('.views-field-nid:not(.copy-nid-processed)');
      const clipboardAttrElements = context.querySelectorAll('[data-clipboard="true"]:not(.clipboard-processed)');

      makeCopyable(nidElements, 'copy-nid-processed');
      makeCopyable(clipboardAttrElements, 'clipboard-processed');
    }
  };



  Drupal.behaviors.searchIconEnhancer = {
  attach(context) {
    once('search-icon-form', '#search-block-form', context).forEach((form) => {
      form.style.position = 'relative';
    });
  },
};

} (Drupal, drupalSettings, once, feather));
